import React from 'react';
import './myticket.css';
import { useNavigate } from 'react-router-dom';
 
import Myticketinfo from '../components/common/myticketinfo';
import mti1 from '../assets/mtiIcon.svg';
import mti2 from '../assets/mti2Icon.svg';
import mti3 from '../assets/mti3Icon.svg';

const DownloadIcon = () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/>
        <polyline points="7 10 12 15 17 10"/>
        <line x1="12" y1="15" x2="12" y2="3"/>
    </svg>
);
 
const ShareIcon = () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="18" cy="5" r="3"/>
        <circle cx="6" cy="12" r="3"/>
        <circle cx="18" cy="19" r="3"/>
        <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/>
        <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/>
    </svg>
);
 
const Myticket = () => {
    const navigate = useNavigate();
 
    return (
        <div className="hcontainer">
            <div className="ticketPage">
                <div className="mytickettitlediv">
                    <div
                        className="myticketback"
                        onClick={() => navigate(-1)}
                       
                    />
 
                    <h5>Ticket</h5>
                    <div className="tickdiv3" />
                </div>
                <div className="myticket">
 
                    <div className="myticketimg" />
 
                    <div className="myticketcontent">
                        <div className="myt1">
                            <h6 className="myt1title">Egypt Fashion Week 2026</h6>
                            <span className="vip">★ VIP Access</span>
                        </div>
 
                        <div className="myticketinfoo">
                            <Myticketinfo mticon1={mti1} tinfo1="Date"  tinfo2="May 15, 2026" />
                            <Myticketinfo mticon1={mti2} tinfo1="Time"  tinfo2="19:00 – 23:00" />
                            <Myticketinfo mticon1={mti3} tinfo1="Venue" tinfo2="Cairo International Convention Center" />
                        </div>
                        <div className="ticketDivider">
                            <div className="notch" />
                            <div className="notchh"  />
                        </div>
                        <div className="seatsdiv">
                            <div className="seatsrow">
                                <div className="seats3">
                                    <h6 className="seatst1">Section</h6>
                                    <h6 className="seatst2">VIP — Row A</h6>
                                </div>
                                <div className="seats3">
                                    <h6 className="seatst1">Seat</h6>
                                    <h6 className="seatst2">12</h6>
                                </div>
                            </div>
                        </div>
                        <button className="viewqrcode">
                            View QR Code
                        </button>
                        <div className="actions">
                            <button className="actionBtn">
                                <DownloadIcon /> Download
                            </button>
                            <button className="actionBtn">
                                <ShareIcon /> Share
                            </button>
                        </div>
 
                        <div className="noticebox">
                            This ticket is personal and non-transferable. Please arrive 30 minutes early. Screenshots may be accepted at entry.
                        </div>
 
                    </div>
                </div>
 
            </div>
        </div>
    );
};
 
export default Myticket;